<template functional>
  <router-link v-if="props.link" :to="{ name: 'home' }" class="d-inline-block">
    <div
      class="main-logo"
      :class="props.customClass"
      v-html="require('@/assets/img/logo.svg')" />
  </router-link>
  <div
    v-else
    class="main-logo"
    :class="props.customClass"
    v-html="require('@/assets/img/logo.svg')" />
</template>

<script>
  export default {
    props: {
      customClass: String,
      link: Boolean
    }
  }
</script>

<style lang="scss">
.main-logo {
  display: inline-block;
  padding: 8px 0;
  margin-right: 12px;
  svg {
    // width: 130px;
    min-width: 140px;
    height: 50px;
  }
}
</style>
